import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Button from '~/components/Button'
import TextInput from '~/components/TextInput'

export const FirstnameStep = ({ onNextStep }: { onNextStep: () => void }) => {
  const { control, getFieldState, formState, trigger } = useFormContext()
  const fieldState = getFieldState('firstname', formState)

  useEffect(() => {
    // mark empty required field as invalid immediately
    trigger('firstname')
  }, [trigger])

  return (
    <div className='flex flex-col items-center md:w-1/2 w-full mx-auto p-4'>
      <FontAwesomeIcon
        icon='handshake'
        className='mb-4 h-[150px] w-[150px] text-icon-secondary'
      />

      <div className='mb-4'>
        <h1 className='mb-4 text-3xl font-medium text-text-primary'>Je voornaam</h1>

        <p>Laten we even kennismaken.</p>
      </div>

      <Controller
        control={control}
        name='firstname'
        rules={{
          required: true
        }}
        render={({ field }) => (
          <TextInput
            shouldValidate={false}
            showValidationIcon={false}
            icon='user'
            {...field}
          />
        )}
      />

      <Button
        onClick={() => {
          if (!fieldState.invalid) {
            onNextStep()
          }
        }}
        type='button'
        className='w-full'
        disabled={fieldState.invalid && !fieldState.isDirty}
      >
        Voornaam bevestigen
      </Button>
    </div>
  )
}
